import { useTheme } from '@homebotapp/hb-react-component-catalog'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { ImportantNowCard } from '../../ImportantNowCard'
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const shareMessages = defineMessages({
  nav: {
    id: 'ImportantNow.share.nav',
    defaultMessage: 'Share now'
  }
})

const Share = () => {
  const { theme } = useTheme()
  const intl = useIntl()
  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      winType='Share'
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.shareHomebot.buildPath()}
      tracking={{
        guid: 'J7vRfKwA6pZ2oM1xVnBcD',
        ui_context: 'homeownerDashboardWinShare',
        descriptor: 'User clicked on Share card in Whats Important Now section in Homeowner Dashboard'
      }}
      navMessage={intl.formatMessage(shareMessages.nav)}
    >
      <FormattedMessage id='ImportantNow.spotlight.share' defaultMessage='Share Homebot to help friends & family' />
    </ImportantNowCard>
  )
}

Share.propTypes = {}

export default Share
